import styled from "styled-components";
import { Card, InputGroup } from "react-bootstrap";
import { Calendar } from "primereact/calendar";

const StyledCard = styled(Card)`
    border: 1px solid #e4e4e4;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    padding: 1.5em;
    padding-right: 2em;
    padding-left: 2em;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1em;
`;

const stylesBox = {
    box1: {
        marginTop: "1em",
        borderTop: "1.8px solid #CBCCCC",
        paddingTop: "1em",
        // eslint-disable-next-line sonarjs/no-duplicate-string
        justifyContent: "space-between",
    },
    box2: {
        display: "flex",
        alingItems: "center",
        justifyContent: "space-between",
    },
    box3: {
        display: "flex",
        alingItems: "center",
        height: 50,
    },
};

const stylesBoxsModalDetalhes = {
    box1: {
        marginTop: -10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
    },
    box2: { width: 200 },
    box3: {
        marginTop: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
    },
    box4: {
        display: "flex",
        width: 500,
        justifyContent: "space-between",
    },
    box5: {
        display: "flex",
        width: "100%",
        justifyContent: "center",
    },
};

const StyledCalendar = styled(Calendar)`
    &.p-calendar .p-inputtext {
        border: transparent !important;
        background: #fff;
        height: 2.1em;
        cursor: pointer;
        font-size: 17px;
    }
`;

const StyledInputGroupCalendar = styled(InputGroup)`
    border-radius: 4px !important;
    box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    transition-timing-function: ease !important;
    transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1) !important;
    width: 100%;
    border: 1px solid #fff !important;
    background-color: #fff !important;
    &:hover {
        border: 1px solid #9654ff !important;
    }
    &:active {
        border: 1px solid #9654ff !important;
    }
    &:focus {
        border: 1px solid #9654ff !important;
    }
    &:focus-visible {
        border: 1px solid #9654ff !important;
        outline: none;
    }
`;

export {
    StyledCard,
    stylesBox,
    stylesBoxsModalDetalhes,
    StyledCalendar,
    StyledInputGroupCalendar,
};
